const MINUTE_IN_MILLISECONDS = 60 * 1000
const initializedRanges = new WeakSet()

function localDateTimeInMilliseconds(value) {
  const parts = value.match(/\d+/g)?.map(Number)
  if (!parts || parts.length < 5) return null

  const [year, month, day, hour, minute, second = 0] = parts
  return Date.UTC(year, month - 1, day, hour, minute, second)
}

function durationLabel(totalMinutes) {
  const days = Math.floor(totalMinutes / (24 * 60))
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60)
  const minutes = totalMinutes % 60
  const parts = []

  if (days) parts.push(`${days} 天`)
  if (hours) parts.push(`${hours} 小時`)
  if (minutes || parts.length === 0) parts.push(`${minutes} 分鐘`)

  return parts.join(" ")
}

export function initializeDateTimeRanges() {
  document.querySelectorAll("[data-date-time-range]").forEach((range) => {
    if (initializedRanges.has(range)) return

    const startInput = range.querySelector("[data-date-time-range-start]")
    const endInput = range.querySelector("[data-date-time-range-end]")
    const summary = range.querySelector("[data-date-time-range-summary]")
    if (!startInput || !endInput || !summary) return

    summary.id ||= `${endInput.id || startInput.id}-summary`
    const inputs = [startInput, endInput]
    inputs.forEach((input) => {
      const descriptions = new Set(input.getAttribute("aria-describedby")?.split(/\s+/).filter(Boolean))
      descriptions.add(summary.id)
      input.setAttribute("aria-describedby", [...descriptions].join(" "))
    })

    const updateSummary = () => {
      const start = localDateTimeInMilliseconds(startInput.value)
      const end = localDateTimeInMilliseconds(endInput.value)

      range.removeAttribute("data-date-time-range-state")
      endInput.removeAttribute("aria-invalid")
      endInput.setCustomValidity("")

      if (start === null || end === null) {
        summary.textContent = "選好起訖時間後，這裡會顯示會議長度。"
        return
      }

      const duration = Math.round((end - start) / MINUTE_IN_MILLISECONDS)
      if (duration <= 0) {
        range.dataset.dateTimeRangeState = "invalid"
        endInput.setAttribute("aria-invalid", "true")
        endInput.setCustomValidity("結束時間必須晚於開始時間。")
        summary.textContent = "結束時間需晚於開始時間。"
        return
      }

      range.dataset.dateTimeRangeState = "valid"
      summary.textContent = `會議長度：${durationLabel(duration)}`
    }

    startInput.addEventListener("input", updateSummary)
    endInput.addEventListener("input", updateSummary)
    updateSummary()
    initializedRanges.add(range)
  })
}
